import { Component } from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Body from './Body';
import getGrid from '../../utils/getGrid';

class Timeline extends Component {
  render() {
    const { time, timebar, tracks, sticky, clickElement } = this.props;

    const grid = getGrid(timebar);

    return (
      <div
        className=" relative overflow-hidden border "
        style={{ width: time.timelineWidthStyle }}
      >
        <Header
          time={time}
          timebar={timebar}
          width={time.timelineWidthStyle}
          sticky={sticky}
        />
        <Body
          time={time}
          grid={grid}
          tracks={tracks}
          clickElement={clickElement}
        />
      </div>
    );
  }
}

Timeline.propTypes = {
  now: PropTypes.instanceOf(Date),
  time: PropTypes.shape({
    fromX: PropTypes.func.isRequired,
    toStyleLeftAndWidth: PropTypes.func,
    timelineWidthStyle: PropTypes.string,
  }).isRequired,
  timebar: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
    }).isRequired
  ).isRequired,
  tracks: PropTypes.arrayOf(PropTypes.shape({})),
  sticky: PropTypes.shape({}),
  clickElement: PropTypes.func,
};

export default Timeline;
